import { useBreakpoints, useCssVar } from '@vueuse/core'

const breakpointsLabels = ['xs', 'sm', 'md', 'lg', 'xl'] as const
type BreakpointLabels = typeof breakpointsLabels
type BreakpointLabel = BreakpointLabels[number]
type BreakpointDictionary = Record<BreakpointLabel, number>
const breakpointDict: Partial<BreakpointDictionary> = {
    lg: 992,
    md: 768,
    sm: 576,
    xl: 1200,
    xs: 0,
}

// for (let i = 0, len = breakpointsLabels.length; i < len; i++) {
//     const breakpointName = breakpointsLabels[i]
//     breakpointDict[breakpointName] = Number(
//         useCssVar(`--breakpoint-${breakpointName}`, document.documentElement).value.slice(0, -2)
//     )
// }
export const breakpointsMng = useBreakpoints(breakpointDict as BreakpointDictionary)
